<template>
  <modal name="fullModal" :width="500" :height="'100%'" :clickToClose="false"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <div id="div_fullModal" class="popup boundary">
      <div class="pop_tit">
        <span>{{ getLastStoreCompObj.title }}</span>
        <a href="javascript:void(0);" title="close" class="pop_close" @click="close">close</a>
      </div>
      <div class="pop_con_wrap" style="padding: 0">
        <div class="pop_con">
          <div class="pop_con_bg" style="padding: 0">
            <!-- <AtmObstHstr :isModal="true" /> -->

            <component :is="getLastStoreCompObj.comp" v-bind="getLastStoreCompObj.propData" @jobDone="close"/>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
  name: 'FullModal',
  components: {
  },
  data: () => ({
    comp: {},
    propData: {},
    title: ''
  }),
  computed: {
    getRoutePath () {
      return this.$route.path
    },
    getStoreCompObjs () {
      return window.$store.getters['ModalStore/getModalObjs']
    },
    getLastStoreCompObj () {
      if (this.getStoreCompObjs && this.getStoreCompObjs.length > 0) {
        return this.getStoreCompObjs[this.getStoreCompObjs.length - 1]
      }
      return { title: '', comp: null, propData: null }
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {
    getRoutePath (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.close()
      }
    }
  },
  methods: {
    beforeOpen ({ params }) {

    },
    opened () {
      let popLeft = (($(window).width() - $(`#div_fullModal`).outerWidth()) / 2)
      let popTop = (($(window).height() - $(`#div_fullModal`).outerHeight()) / 2)
      if (popLeft < 0) popLeft = 0
      if (popTop < 0) popTop = 0
      $('#popupMask').fadeIn()
      $(`#div_fullModal`).css({'left': popLeft, 'top': popTop}).fadeIn().addClass('on')
    },
    closed () {
      $('#pop_up').fadeOut().removeClass('on')
      $('#popupMask').fadeOut()
    },
    close () {
      if (this.getStoreCompObjs.length <= 1) {
        this.closed()
        this.$modal.hide('fullModal')
      }
      window.$store.commit('ModalStore/hideModal', this.getStoreCompObjs.length - 1)
    }
  }
}
</script>

<style scoped>
.popup.boundary {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/FullModal.vue